import type { Dayjs } from "dayjs";
import { useState } from "react";
import { startOfPreviousMonth } from "../misc/dateUtils";

export interface CalculationFilters {
  readonly text: string;
  readonly customerId: string | null;
  readonly month: Dayjs;
}

export const useCalculationsSearch = () => {
  const [calculationsSearch, setCalculationsSearch] = useState<CalculationFilters>({
    text: "",
    customerId: null,
    month: startOfPreviousMonth(),
  });
  return { calculationsSearch, setCalculationsSearch };
};
